
import ZUtil from './zutil';

var ZToolTip = {
	init: function() {
		if (!ZToolTip.initialized) {
			document.body.addEventListener("mousemove", ZToolTip.handleTooltips);
			ZToolTip.initialized = true;
		}
	},
	handleTooltips: function(e) {
		var pos = ZUtil.getMousePosition(e), element, names, tip, rect, cn, debug = false, classname;
		element = document.elementFromPoint(pos[0], pos[1]);	
		while (element && element !== document.body) {
			// support svg and DOM elements
			classname = element.getAttribute("class");
			if (classname && 
				(("" + classname).indexOf("ZToolTip") !== -1 || ("" + classname).indexOf("ZTip") !== -1)) {
				if (element === ZToolTip.tooltipee || element === ZToolTip.tip) {
					return;
				}
				if (ZToolTip.tooltipee && !debug) {
					ZToolTip.closeTooltips(e);
				} else if (ZToolTip.tooltiptimeout) {
					clearTimeout(ZToolTip.tooltiptimeout);
				}
				names = classname.split(' ');
				for (var i = 0, len = names.length; i < len; ++i) {
					if (names[i].length > "ZToolTip".length && names[i].startsWith("ZToolTip")) {
						cn = names[i];
						break;
					}
				}
				tip =  ZToolTip.tip;
				if (!tip) {
					tip = document.createElement('div');
					document.body.appendChild(tip);
					ZToolTip.tip = tip;
				}
				tip.className = "ZTip " + cn.replace("Tool", "");
				tip.innerHTML = element.getAttribute("data-tooltip") || element.title;

				ZToolTip.tooltipee = element;
				ZToolTip.tooltiptitle = element.title;
				element.title = "";
				rect = element.getBoundingClientRect();
				var DISTANCE_FROM_TIPEE = 20;
				if (cn.endsWith("Right")) {
					tip.style.left = (rect.left + rect.width + DISTANCE_FROM_TIPEE) + "px";
					tip.style.top = (rect.top + rect.height/2 - tip.offsetHeight/2) + "px";
				} else if (cn.endsWith("Left")) {
					tip.style.left = (rect.left -  tip.offsetWidth - DISTANCE_FROM_TIPEE) + "px";
					tip.style.top = (rect.top + rect.height/2 - tip.offsetHeight/2) + "px";
				} else if (cn.endsWith("Top")) {
					tip.style.left = (rect.left + rect.width/2 - tip.offsetWidth/2) + "px";
					tip.style.top = (rect.top - tip.offsetHeight - DISTANCE_FROM_TIPEE) + "px";
				} else if (cn.endsWith("Bottom")) {
					tip.style.left = (rect.left + rect.width/2 - tip.offsetWidth/2) + "px";
					tip.style.top = (rect.top + rect.height + DISTANCE_FROM_TIPEE) + "px";
				}
				tip.style.opacity = 1;
				ZToolTip.tooltiptimeout = setTimeout(function() { ZToolTip.closeTooltips() }, 5000);
				return;
			}
			element = element.parentNode;
		}
		if (ZToolTip.tooltipee && !debug) {
			ZToolTip.tip.style.opacity = 0;
			ZToolTip.tooltipee.title = ZToolTip.tooltiptitle
			ZToolTip.tooltipee = null;
		}
  	},
	closeTooltips: function(e) {
		var debug = false;
		if (ZToolTip.tooltipee && !debug) {
			if (ZToolTip.tooltiptimeout) {
				clearTimeout(ZToolTip.tooltiptimeout);
			}
			ZToolTip.tip.style.opacity = 0;
			ZToolTip.tooltipee.title = ZToolTip.tooltiptitle;
			ZToolTip.tooltipee = null;
		}
  	}
}
export default ZToolTip;



// WEBPACK FOOTER //
// ./src/ztooltip.js